import { useEffect } from "react";
import { instagramReels } from "../data/content";

function ReelsSection() {
  useEffect(() => {
    if (window.instgrm?.Embeds?.process) {
      window.instgrm.Embeds.process();
      return;
    }

    const script = document.createElement("script");
    script.src = "https://www.instagram.com/embed.js";
    script.async = true;
    script.onload = () => {
      if (window.instgrm?.Embeds?.process) {
        window.instgrm.Embeds.process();
      }
    };
    document.body.appendChild(script);

    return () => {
      document.body.removeChild(script);
    };
  }, []);

  return (
    <section className="section alt reels-section">
      <div className="section-title">
        <p>Instagram Reels</p>
        <h2>Watch Our Work in Action</h2>
      </div>
      <a
        className="instagram-btn"
        href="https://www.instagram.com/aarab.sharma.31/?utm_source=ig_embed&ig_rid=412479dc-9085-4e61-971f-fbf9cd424bc0"
        target="_blank"
        rel="noopener noreferrer"
      >
        Visit Instagram Profile
      </a>
      <div className="reels-grid">
        {instagramReels.map((reel) => (
          <div key={reel.url} className="reel-embed">
            <blockquote
              className="instagram-media"
              data-instgrm-permalink={`${reel.url}?utm_source=ig_embed`}
              data-instgrm-version="14"
            >
              <a href={reel.url} target="_blank" rel="noopener noreferrer">
                View this reel on Instagram
              </a>
            </blockquote>
          </div>
        ))}
      </div>
    </section>
  );
}

export default ReelsSection;
